import React from "react";

import {ReactComponent as OkSelected} from 'assets/img/okSelected.svg';
import {ReactComponent as OkNotSelected} from 'assets/img/okNotSelected.svg';
import RadioCircleSvg from 'gui/components/formikRadioInput/components/radio/components/radioCircleSvg';

export interface IRadioProps {
  state?: boolean;
  onClick?: (state: boolean) => void;
  labelTrue?: string;
  labelFalse?: string;
}

const OkRadioCircle = (props: IRadioProps) => <RadioCircleSvg
  {...props}
  radioSelectedIcon={OkSelected}
  radioNotSelectedIcon={OkNotSelected}
/>

OkRadioCircle.defaultProps = {};
export default OkRadioCircle;
